import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { StatusPill } from '../ui/StatusPill';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { projects } from '../../data/projects';
export function FeaturedProjects() {
  const featuredProjects = projects.filter(p => p.featured).slice(0, 3);
  return <section className="py-20 bg-ivory" data-id="element-108" data-mp="22ddtjcbxghc6">
      <div className="max-w-7xl mx-auto px-4" data-id="element-109" data-mp="22clzi5xzaro0">
        <SectionHeading title="Featured Projects" subtitle="Transformative initiatives driving sustainable development across Africa" data-id="element-110" data-mp="1xeaq1wblij6b" />

        <div className="grid md:grid-cols-3 gap-8 mt-12" data-id="element-111" data-mp="1sgrdr1ygkgh0">
          {featuredProjects.map((project, index) => <motion.div key={project.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-112" data-mp="1ni7oosokiokf" data-mpi={index}>
              <Card hover className="h-full flex flex-col" data-id="element-113" data-mp="njfu7jzpeuq2">
                <div className="mb-4" data-id="element-114" data-mp="nhwdxte1sjoa">
                  <StatusPill status={project.status} data-id="element-115" data-mp="1b91nxrxb4hqo">
                    {project.status.toUpperCase()}
                  </StatusPill>
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-116" data-mp="1g6jzzr6mfd2w">
                  {project.title}
                </h3>
                <div className="flex items-center gap-2 text-sm text-gray-600 mb-3" data-id="element-117" data-mp="16a6xq4x0fqwj">
                  <MapPinIcon size={16} data-id="element-118" data-mp="3mz41rk970zqu" />
                  <span data-id="element-119" data-mp="3my1bnejp31bz">{project.countries.join(', ')}</span>
                </div>
                <p className="text-gray-600 mb-4 flex-1" data-id="element-120" data-mp="3r17hil2waqhx">
                  {project.description}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-border" data-id="element-121" data-mp="1xgxfrvqqlob6">
                  <span className="text-sm font-medium text-au-green" data-id="element-122" data-mp="1sjxb9p9jctm6">
                    {project.sector}
                  </span>
                  <span className="text-sm font-bold text-charcoal" data-id="element-123" data-mp="1nq2sco1r8io5">
                    {project.budget}
                  </span>
                </div>
              </Card>
            </motion.div>)}
        </div>

        <div className="text-center mt-12" data-id="element-124" data-mp="19se89ifihfk5">
          <Link to="/projects" data-id="element-125" data-mp="19rl7qz75bmag">
            <Button variant="secondary" className="flex items-center gap-2 mx-auto" data-id="element-126" data-mp="19uh8evadop2l">
              View All Projects
              <ArrowRightIcon size={20} data-id="element-127" data-mp="zv9sq1g68icb" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}